import React from "react";

// Styles
import styles from "./style.module.scss";

// Types
import { APIChatMessage } from "../../../types";

import Typography from "../../Typography";
import FileMessage from "../FileMessage";

interface MessageRowProps {
  message: APIChatMessage;
}

const MessageRow: React.FC<MessageRowProps> = ({ message }) => {
  const rowClass = `${styles.messageRow} ${styles[`messageRow_${message.role}`]}`;
  const messageClass = `${styles.messageRow_content} ${styles[`messageRow_content_${message.role}`]}`;

  // Main Render
  return (
    <div className={rowClass}>
      <div className={messageClass} dir="auto">
        {message.text && (
          <Typography variant="p" className={styles.messageRow_content_text}>
            {message.text}
          </Typography>
        )}
        {message.file && <FileMessage file={message.file} />}
      </div>
    </div>
  )
}
export default MessageRow
